import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "CookiesMainView"
}
const _hoisted_2 = { class: "BigPlaceholder P-Rel" }
const _hoisted_3 = { class: "BigContainer" }
const _hoisted_4 = { class: "BigHeader" }
const _hoisted_5 = {
  class: "D-Flex HeaderFlex",
  style: {}
}
const _hoisted_6 = {
  key: 0,
  class: "D-Flex HeaderFilterIconDiv"
}
const _hoisted_7 = { class: "F-Bold F1_75em BigHeaderText" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter MobileHider" }, null, -1)
const _hoisted_9 = { class: "HeaderButtons" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  style: {},
  class: "V-Auto"
}
const _hoisted_12 = {
  key: 1,
  style: {"white-space":"nowrap"},
  class: "V-Auto"
}
const _hoisted_13 = {
  class: "V-Auto",
  style: {"white-space":"nowrap"}
}
const _hoisted_14 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesFilterPannel = _resolveComponent("CookiesFilterPannel")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesTabs = _resolveComponent("CookiesTabs")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.Access('Sales_View'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.Filter)
            ? (_openBlock(), _createBlock(_component_CookiesFilterPannel, {
                key: 0,
                onCloseMe: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ShowFilter = false)),
                FilterSettings: _ctx.Filter,
                ShowFilter: _ctx.ShowFilter
              }, null, 8, ["FilterSettings", "ShowFilter"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.Filter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_CookiesIcon, {
                        ToolTip: _ctx.Translate('Filter'),
                        class: "FilterButton HoverUp",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ShowFilter = true)),
                        style: {"width":"2.2em","height":"2.2em","margin":"auto 0.5em","padding":"0em 1em"},
                        ID: 'Filter'
                      }, null, 8, ["ToolTip"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.Translate('Sales')), 1),
                _createVNode(_component_CookiesTabs, {
                  Router: true,
                  class: "M-Auto HeaderTabs",
                  Default: _ctx.Tabs[0],
                  Tabs: _ctx.Tabs
                }, null, 8, ["Default", "Tabs"]),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Buttons, (button) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: button.Name,
                    class: ""
                  }, [
                    (button.Visible === undefined || button.Visible)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: ($event: any) => (button.this.ButtonsFunctions(button.Function)),
                          class: _normalizeClass([button.Class, "DialogHeaderButton BGMain F1_25em CookiesFade D-Flex"]),
                          style: _normalizeStyle(button.Style)
                        }, [
                          (button.Icon)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                _createVNode(_component_CookiesIcon, {
                                  Color: button.IconColor,
                                  class: "SQR1_5em",
                                  ID: button.Icon
                                }, null, 8, ["Color", "ID"])
                              ]))
                            : _createCommentVNode("", true),
                          (button.Indent)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(button.Indent), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.Translate(button.Name)), 1)
                        ], 14, _hoisted_10))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", {
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.PhoneSearchEnabled = false)),
                class: "D-Flex CookiesSearchInputContainer",
                style: _normalizeStyle(_ctx.$store.getters.Direction === 'ltr' ? 'margin-right: 0em;': 'margin-left: 0em;')
              }, [
                _createVNode(_component_CookiesIcon, {
                  class: "CookiesSearchIcon HoverUp",
                  ID: ('Filter' as IconsIDs)
                }),
                _createVNode(_component_CookiesIcon, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.PhoneSearchEnabled = !_ctx.PhoneSearchEnabled)),
                  Color: {ColorA: _ctx.Search !== '' ? _ctx.Theme.UserColors.fourth : ''} as IconColor,
                  class: "CookiesSearchIcon HoverUp",
                  ID: ('Search' as IconsIDs),
                  style: {"padding-inline-end":"1.5em"}
                }, null, 8, ["Color"]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Search) = $event)),
                  class: _normalizeClass(["CookiesSearchInput CookiesFade color2 F1_25em", _ctx.PhoneSearchEnabled ? '' : 'D-None']),
                  style: _normalizeStyle(_ctx.PhoneSearchEnabled ? 'display: block': ''),
                  placeholder: _ctx.Translate('Search...')
                }, null, 14, _hoisted_14), [
                  [_vModelText, _ctx.Search]
                ]),
                _createVNode(_component_CookiesIcon, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.PhoneSearchEnabled = false)),
                  style: _normalizeStyle([_ctx.PhoneSearchEnabled ? 'display: block;': 'display: none;', {"right":"2.5em","top":"1.5em","transform":"rotate(-90deg)"}]),
                  class: "HeaderSmall SQR1_5em V-Auto HoverUp P-Abs",
                  ID: ('SortingArrow' as IconsIDs)
                }, null, 8, ["style"]),
                _createVNode(_component_CookiesIcon, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.Search = '')),
                  style: _normalizeStyle([_ctx.PhoneSearchEnabled ? 'display: block;': 'display: none;', {"right":"4.5em","top":"1.5em"}]),
                  class: "HeaderSmall SQR1_5em V-Auto HoverUp P-Abs",
                  ID: ('Delete' as IconsIDs)
                }, null, 8, ["style"])
              ], 36)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["BigBody P-Rel", _ctx.FillBodyHeight])
            }, [
              _createVNode(_component_router_view, {
                Search: _ctx.Search,
                ParentThis: _ctx.This
              }, null, 8, ["Search", "ParentThis"])
            ], 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}